import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    list: [],
    totalCount: 0,
    isSwitchOn: false,
    pagination: {
      page: 1,
      size: 25
    }
  },
  mutations: {
    setList(state, payload) {
      state.list = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setIsSwitchOn(state, payload) {
      state.isSwitchOn = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    transaction(context, id) {
      return api.transaction({ id });
    },
    getTransactionSwitch({ commit }) {
      api.getTransactionSwitch().then(res => {
        commit('setIsSwitchOn', res.data);
      });
    },
    transactionSwitch(context, toggle) {
      return api.transactionSwitch({ toggle });
    }
  }
};

appStore.registerModule('leagueSettleRecord', store);
